export default {
  common: {
    save: "जतन करा",
    cancel: "रद्द करा",
    back: "मागे",
    submit: "सबमिट करा",
    loading: "लोड होत आहे…",
    yes: "होय",
    no: "नाही",
    confirm: "पुष्टी करा",
    close: "बंद करा",
    search: "शोधा",
    all: "सर्व",
    done: "झाले",
    logout: "लॉग आउट",
    language: "भाषा",
    selectLanguage: "तुमची भाषा निवडा",
    saving: "जतन होत आहे…",
    saved: "जतन झाले",
    viewAll: "सर्व पहा",
    filters: "फिल्टर",
  },
  nav: {
    home: "मुख्यपृष्ठ",
    installs: "इंस्टॉलेशन",
    requests: "विनंत्या",
    orders: "ऑर्डर",
    profile: "प्रोफाइल",
    leads: "लीड्स",
    service: "सेवा",
    payouts: "पेआउट्स",
    toolkit: "टूलकिट",
  },
  profile: {
    yourAccount: "तुमचे खाते",
    title: "प्रोफाइल.",
    city: "शहर",
    state: "राज्य",
    pinCode: "पिन कोड",
    pinCodeHelp: "तुमचा प्रदेश म्हणजे हा पिन कोड ज्या परवानगीप्राप्त क्षेत्रात येतो तो.",
    upiId: "यूपीआय आयडी (पेआउटसाठी)",
    saveProfile: "प्रोफाइल जतन करा",
    preferredLanguage: "आवडती भाषा",
    logoutConfirm: "तुम्हाला खरंच लॉग आउट करायचे आहे का?",
    linkedAddresses: "जोडलेले पत्ते",
    noAddresses: "अजून कोणताही पत्ता जतन केलेला नाही.",
    referFriend: "मित्राला रेफर करा",
    referFriendSub: "तुमचा कोड शेअर करा — ते सोलर बसवतील तेव्हा तुम्हाला बक्षीस मिळेल.",
    myReferrals: "माझे रेफरल्स",
    shareFriend: "मित्रासोबत शेअर करा",
    secureNote: "तुमचा डेटा सुरक्षित फोन ओटीपीद्वारे सत्यापित आहे — पासवर्ड लक्षात ठेवण्याची किंवा गमावण्याची गरज नाही.",
    toolkit: "टूलकिट",
    incentiveSchemes: "प्रोत्साहन योजना",
  },
  tickets: {
    myRequests: "माझ्या विनंत्या",
    raiseComplaint: "तक्रार नोंदवा",
    cancelRequest: "विनंती रद्द करा",
    cancelConfirmTitle: "ही विनंती रद्द करायची का?",
    cancelConfirmBody: "आम्ही या सेवा विनंतीवरील काम थांबवू. तुम्ही नंतर पुन्हा नवीन विनंती करू शकता.",
    cancelledToast: "विनंती रद्द केली",
    keepRequest: "नाही, ठेवा",
    noRequests: "अजून कोणतीही सेवा विनंती नाही.",
    statusOpen: "सुरू",
    statusInProgress: "प्रगतीपथावर",
    statusOnHold: "थांबवले",
    statusActionNeeded: "कारवाई आवश्यक",
    statusCompleted: "पूर्ण",
    statusClosed: "बंद",
    statusCancelled: "रद्द",
    statusDropped: "ड्रॉप केले",
    filterAll: "सर्व",
    filterActive: "सक्रिय",
    filterResolved: "निकाली",
    nonServiceable: "सेवा न मिळणारे क्षेत्र",
    raisedOn: "नोंदवले",
    ticketNumber: "तिकीट",
    wipInstall: "इंस्टॉलेशन सुरू आहे",
    raisedByYou: "तुम्ही नोंदवले",
    raisedByTeam: "आमच्या टीमने नोंदवले",
    timeline: "टाइमलाइन",
    pending: "प्रलंबित",
    resolutionSummary: "निराकरण सारांश",
    youRatedPrefix: "तुम्ही याला रेट केले",
    howWasResolution: "निराकरण कसे होते?",
    submitFeedback: "फीडबॅक सबमिट करा",
  },
  home: {
    greeting: "नमस्कार",
    newInstallation: "नवीन इंस्टॉलेशन",
    raiseComplaint: "तक्रार नोंदवा",
    welcomeBack: "पुन्हा स्वागत आहे",
    customerSubtitle: "पूर्वोदयसोबत तुमचा सोलर प्रवास, सर्व एकाच ठिकाणी.",
  },
  sc: {
    requestsTitle: "सेवा विनंत्या",
    requestsForCustomers: "तुमच्या ग्राहकांसाठी",
    kpiOpen: "उघडे",
    kpiResolved: "निराकरण झाले",
    kpiInProblem: "समस्येत",
    raiseRequest: "सेवा विनंती नोंदवा",
    slaBreached: "SLA भंग",
    viewPhotos: "फोटो पहा",
    hidePhotos: "फोटो लपवा",
    noRequestsWindow: "या कालावधीत कोणतीही सेवा विनंती नाही.",
  },
};
